import { Component, inject } from '@angular/core';
import { OPEN_GRAPH_SERVICE } from 'projects/suche-lib/src/lib/services/open-graph.service';
import { LIB_CONFIG } from 'projects/suche-lib/src/projects';
import { OpenGraphService } from '../../service/open-graph.service';

@Component({
  selector: 'now-wbsuche-app-error404',
  templateUrl: './error404.component.html',
  styleUrls: ['error404.component.scss']
})
export class Error404Component {
  public nowPortalBasePath = inject(LIB_CONFIG).nowPortalBasePath;

  constructor() {
    const openGraphService = inject<OpenGraphService>(OPEN_GRAPH_SERVICE, { optional: true });

    openGraphService?.setDescription(
      'Weiterbildungen suchen und finden - bereitgestellt von einer der größten Weiterbildungsdatenbanken Deutschlands.'
    );
  }
}
